import { IArticle, ICrossTherapyArticleLine, IQuantityPerUnit } from '@alberta/konexi-shared';
import { ignore } from 'src/app/common/tracking/tracker';
import { ArticleDto } from 'src/app/shared/models/article/article-dto.model';
import { QuantityPerUnit } from 'src/app/shared/models/article/quantityPerUnit';
import { v4 } from 'uuid';

export class CrossTherapyArticleLineViewModel implements ICrossTherapyArticleLine {
  _id: string;
  therapyId: number;
  therapyTypeId: number;
  doctorId: string;
  integratedCareId: string;
  salesLineId: string;
  proposedArticleLineId: string;
  articleId: string;
  articleName: string;
  articleDescription: string;
  articleManufacturerNumber: string;
  articleCustomerNumber: string;
  packagingUnitId: string;
  articleInventoryType: number;
  unit: string;
  quantity: number;
  packagingUnitQuantity: number;
  bookingCode: string;
  serialNumber: string;
  batchNumber: string;
  storageLocation: string;
  operatingHours: number;
  validTo: Date;
  resmedTenant: string;
  timestamp: Date;
  archived: boolean;
  price: string;
  totalPrice: string;
  ordered: boolean;

  @ignore()
  article: IArticle = new ArticleDto();
  @ignore()
  packagingUnit: IQuantityPerUnit;

  constructor() {
    this._id = v4();
    this.timestamp = new Date();
    this.archived = false;
  }

  public initialize(article: IArticle) {
    if (!article) {
      throw new Error('CrossTherapyArticleLineViewModel: Article is not defined');
    }
    this.article = article;
    this.articleId = article._id;
    this.articleName = article.name;
    this.articleDescription = article.description;
    this.articleManufacturerNumber = article.manufacturerNumber;
    this.articleInventoryType = article.inventoryType;
    this.articleCustomerNumber = article.customerNumber;
    if (!article.packagingUnits || !article.packagingUnits.length) {
      return;
    }
    this.price = this.article?.listPrice;
    const defaultPackagingUnit = article.packagingUnits.find((f: any) => f.defaultPackagingUnit);
    this.packagingUnit = defaultPackagingUnit || article.packagingUnits[0] || new QuantityPerUnit();

    if (!this.packagingUnit) {
      return;
    }
    this.packagingUnitQuantity = this.packagingUnit.quantity || 1;
    this.quantity === 0 ? (this.quantity = 0) : (this.quantity = this.quantity || 1);
    this.unit = this.packagingUnit.unit;
    this.packagingUnitId = this.packagingUnit._id;
  }
}
